import React, { useEffect, useMemo, useState } from "react";
import * as image from "../../resources/images";
import { getSequnceSort } from "../../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import { selectOptionData, showModal } from "../../redux/actions";
import { Knowladgecheck, postModuleChallenge } from "../../redux/actions/APIs";
import ReactTooltip from "react-tooltip";
const UserKc = ({ kcData, handleIsNext, currentSceneObj, loginType, getCount, handleTab }) => {

    const dispatch = useDispatch();
    const { defaultChildData, selectOptData, socialActivityData, kcSubmitResponse } = useSelector((state) => state.collections);

    const [curentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [optNuggetData, setOptNuggetData] = useState();
    const [getOptionId, setOptionId] = useState();
    const [getOptionIdArr, setOptionIdArr] = useState([]);
    const [getTextAreaValue, setTextAreaValue] = useState("");
    const [isDisabled, setIsDisabled] = useState(false);

    const isExcercise = socialActivityData?.records[0]?.series?.scenes?.length === currentSceneObj?.sequence ? true : false;


    useEffect(() => {
        if (kcData?.length > 0) {
            let qstnIndx = kcData?.findIndex((item) => !item?.attempted)
            if (qstnIndx !== -1) {
                setCurrentQuestionIndex(qstnIndx);
            } else {
                setCurrentQuestionIndex(0);
            }
        }
    }, [kcData])

    useEffect(() => {
        if (selectOptData?.type) {
            dispatch(selectOptionData({ ...selectOptData, type: "" }));
        }
        if (kcData?.length > 0 && kcData[curentQuestionIndex]?.type === "COMMENTQ") {
            if (kcData[curentQuestionIndex]?.options[0]?.answer) {
                setTextAreaValue(kcData[curentQuestionIndex]?.options[0]?.answer);
            } else {
                setTextAreaValue("");
            }
        }
        setIsDisabled(false);
    }, [curentQuestionIndex])

    const handleClick = (index) => {
        setCurrentQuestionIndex(index)
    }

    const handleOptionRadio = (selectedOpt) => {
        let getAllOption = kcData[curentQuestionIndex]?.options;
        getAllOption?.map((data, key) => {

            if (kcData[curentQuestionIndex]?.attempted) {
                data.isUserSelected = true;
            }
            else {
                if (selectedOpt?.id === data?.id) {
                    selectedOpt.attempted = true;
                } else {
                    data.attempted = false;
                }

            }
        })
        let title = isExcercise ? "Food for thought" : selectedOpt?.isCorrect ? "Well Done!" : "Close! Keep Going!";

        // console.log("selectOptData?.type user : ", selectedOpt);
        if ((!loginType || kcData[curentQuestionIndex]?.attempted)) {
            dispatch(selectOptionData({
                type: "ShowNuggetPopup",
                title: title,
                questionData: kcData[curentQuestionIndex],
                optNuggetData: [selectedOpt]
            }));
        } else {
            dispatch(selectOptionData({
                type: "",
                title: title,
                questionData: kcData[curentQuestionIndex],
                optNuggetData: [selectedOpt]
            }));
        }
        setOptNuggetData(selectedOpt);
    }

    const handleOptionCheckBox = (chooseOption) => {
        if (!kcData[curentQuestionIndex]?.attempted) {
            chooseOption.attempted = !chooseOption?.attempted;
        }
        let optArr = [];
        let getAllOption = kcData[curentQuestionIndex]?.options;
        getAllOption?.map((item, key) => {
            if (kcData[curentQuestionIndex]?.attempted) {
                item.isUserSelected = true;
            }
            if (item?.attempted) {
                optArr?.push(item);
            }
        })

        let title = isExcercise ? "Food for thought" : chooseOption?.isCorrect ? "Well Done!" : "Close! Keep Going!";

        if ((!loginType || kcData[curentQuestionIndex]?.attempted)) {
            dispatch(selectOptionData({
                type: "ShowNuggetPopup",
                title: title,
                questionData: kcData[curentQuestionIndex],
                optNuggetData: [chooseOption]
            }));
        } else {
            dispatch(selectOptionData({
                type: "",
                title: title,
                questionData: kcData[curentQuestionIndex],
                optNuggetData: optArr
            }));
        }
        setOptNuggetData(chooseOption);
    }

    const handleNext = () => {
        let getActivityData = socialActivityData?.records[0];
        if(!loginType && isExcercise  && curentQuestionIndex + 1 === kcData?.length) {

            if(!getActivityData?.followUp?.isCompleted){
                handleTab("Reflection");
            }else{
                 handleTab("Challenges");
            }
            dispatch(selectOptionData({ ...selectOptData, type: "" }));
            return;
        }
        if (curentQuestionIndex + 1 === kcData?.length) {
            dispatch(selectOptionData({ ...selectOptData, type: "" }));
            handleIsNext(true);
            return;
        }
        setCurrentQuestionIndex(curentQuestionIndex + 1);
    }

    const handleBack = () => {
        if (curentQuestionIndex === 0) {
            dispatch(selectOptionData({ ...selectOptData, type: "" }));
            handleIsNext(false);
            return;
        }
        setCurrentQuestionIndex(curentQuestionIndex - 1);
    }

    const handleSubmit = (qustionObj, optionObj) => {
        
        let kcpoints = 0;
        optionObj.isUserSelected = true;

        if ((optionObj?.attempted && optionObj?.isCorrect) || isExcercise) {
            qustionObj.attempted = true;

        }
        let title = isExcercise ? "Food for thought" : qustionObj?.attempted ? "Well Done!" : "Close! Keep Going!";
        dispatch(selectOptionData({ ...selectOptData, title: title, type: "ShowNuggetPopup" }));
        // console.log("etOptionId !== optionObj : ",getOptionId, optionObj?.id, getOptionId !== optionObj?.id);
        if (getOptionId !== optionObj?.id) {
            if(!isExcercise){
                 qustionObj.invalidAttempt = qustionObj?.invalidAttempt + 1;
                if (qustionObj?.attempted) {
                    kcpoints = qustionObj.invalidAttempt === 1 ? 10 : 5;
                }
                if (qustionObj.invalidAttempt === 3) {
                    kcpoints = 1;
                    qustionObj?.options?.map((optObj, key) => {
                        if (optObj?.isCorrect) {
                            optObj.attempted = true;
                            qustionObj.attempted = true;
                        } else {
                            optObj.attempted = false;
                        }
                    })
                }
            }else{
                kcpoints = 0;
                 qustionObj.invalidAttempt = 0
            }
           
            const body = {
                questionId: qustionObj?.id,
                invalidAttempt: qustionObj.invalidAttempt,
                type: qustionObj?.type,
                answer: "",
                optionIds: [optionObj?.id],
                kcpoints: kcpoints
            };
            KnowladgecheckHandler(body, qustionObj);
            setOptionId(optionObj?.id);
        }

    }

    const KnowladgecheckHandler = async (attemptBodyData, qustionObj) => {
        let getActivityData = socialActivityData?.records[0];
        let isSkill = false;
        attemptBodyData.activityTime = getCount;
        setIsDisabled(true);
        if (
            getActivityData?.dimName == "Social" ||
            getActivityData?.dimName == "Emotional" ||
            getActivityData?.dimName == "Spiritual"
        ) {
            isSkill = true;
        }
        dispatch(
            Knowladgecheck(
                defaultChildData.id,
                qustionObj?.surveyId,
                getActivityData?.courseId,
                getActivityData?.activityId,
                getActivityData?.skillId,
                attemptBodyData,
                isSkill
            )
        );
        //	getActivityData.points += attemptBodyData?.kcpoints;
        // if (qustionObj?.attempted) {
        //     showPlanCourseData[courseIndex].points += attemptBodyData?.kcpoints;
        // }
    };

    const handleSubmitCheckBox = (qustionObj, optionObj) => {
        let kcpoints = 0;
        let selectOptId = [];
        let correctOptIds = [];
        let attemptOptIds = [];
        let isSubmit = false;
        qustionObj?.options?.map((item, key) => {
            if (item?.attempted) {
                item.isUserSelected = true;
                selectOptId?.push(item?.id);
            }
            if (item?.isCorrect) {
                correctOptIds?.push(item?.id);
            }
            if (item?.attempted && item?.isCorrect) {
                attemptOptIds?.push(item?.id);
            }
        })

        if ((correctOptIds?.length === attemptOptIds?.length && correctOptIds?.length === selectOptId?.length) || isExcercise) {
            qustionObj.attempted = true;
        }
        
        let title = isExcercise ? "Food for thought" : qustionObj?.attempted ? "Well Done!" : "Close! Keep Going!";
        dispatch(selectOptionData({ ...selectOptData, title: title, type: "ShowNuggetPopup" }));
        qustionObj?.options?.map((opt, key) => {
            const idKey = getOptionIdArr?.findIndex((myId) => myId === opt?.id)
            console.log("opt?.attempted && idKey === -1 && !isSubmit : ",opt?.attempted , idKey, isSubmit);
            if (opt?.attempted && idKey === -1 && !isSubmit) {
                isSubmit = true;
            }
            if (!opt?.attempted && idKey !== -1 && !isSubmit) {
                isSubmit = true;
            }
        })


        if (isSubmit) {
            if(!isExcercise){
                qustionObj.invalidAttempt = qustionObj?.invalidAttempt + 1;
                if (qustionObj?.attempted) {
                    kcpoints = qustionObj.invalidAttempt === 1 ? 10 : 5;
                }
                if (qustionObj.invalidAttempt === 3) {
                    kcpoints = 1;
                    qustionObj?.options?.map((optObj, key) => {
                        if (optObj?.isCorrect) {
                            optObj.attempted = true;
                            qustionObj.attempted = true;
                        } else {
                            optObj.attempted = false;
                        }
                    })
                }
            }else{
                qustionObj.invalidAttempt = 0;
                kcpoints = 0;
            }
            const body = {
                kcpoints: kcpoints,
                questionId: qustionObj?.id,
                optionIds: selectOptId,
                invalidAttempt: qustionObj.invalidAttempt,
                type: qustionObj?.type,
                answer: "",
                activityTime: "",
                isKc: !isExcercise ? true : false,
            };
            KnowladgecheckHandler(body, qustionObj);
            // console.log("KnowladgecheckHandler : ", body, qustionObj);
            setOptionIdArr(selectOptId);
        }
    }

    const handelCommentChange = (qustionObj) => {
        qustionObj.attempted = true;
        qustionObj.options[0].answer = getTextAreaValue;
        const body = {
            questionId: qustionObj?.id,
            invalidAttempt: qustionObj.invalidAttempt,
            type: qustionObj?.type,
            answer: getTextAreaValue,
            optionIds: [],
        };
        KnowladgecheckHandler(body, qustionObj);
        handleNext()
    }

    const handleTextAreaChange = (e) => {
        const value = e.target.value.trimStart()
        setTextAreaValue(value);
    };

    const isShowLesson = ()=>{
        let isNext = false;

        if(loginType && curentQuestionIndex+1 === currentSceneObj?.kc?.length){
            if(!currentSceneObj?.isCompleted){
                isNext = true;
            }
            if (loginType && currentSceneObj?.kc?.length > 0 && currentSceneObj?.kc?.some((item)=> !item?.attempted )){
                isNext = true;
            }
            if(socialActivityData?.records[0]?.series?.scenes?.length === currentSceneObj?.sequence){
                isNext = true;
            }
        }
        return isNext;
    }

    const isSubmitDisabled = ()=>{
         let isSubmit = false;
        if(!getTextAreaValue && kcData[curentQuestionIndex]?.type === "COMMENTQ"){
            isSubmit = true;
        }
        if(kcData[curentQuestionIndex]?.type !== "COMMENTQ" && kcData[curentQuestionIndex]?.options?.every((item)=> !item?.attempted)){
            isSubmit = true;
        }  
         return isSubmit;                   
    }

    useEffect(()=>{
        if(kcSubmitResponse){
            setIsDisabled(false);
        }
    },[kcSubmitResponse])
    // console.log("isSubmitDisabled : ", isSubmitDisabled(), isDisabled, kcData[curentQuestionIndex]);
    // console.log("isShowLesson : ", isShowLesson(), loginType , curentQuestionIndex+1 , kcData,isSubmitDisabled(), kcData[curentQuestionIndex]?.options?.every((item)=> !item?.attempted));
    // console.log("kcData[curentQuestionIndex] : ",kcData[curentQuestionIndex])
    return (
        <>
            <div className="knowledgechecknavigation">
                <ul className={`${kcData?.length===2 && "KCtwoQuestion"}`}>
                    {kcData?.map((data, index) => (
                        <li
                            key={index}
                            className={`activeQuestion  ${loginType && data?.attempted
                                ? "complteQuestion "
                                : curentQuestionIndex == index
                                    ? ""
                                    : "lockedquestion"
                                } pointer`}
                            onClick={() => handleClick(index)}
                        >
                            <span className="br-50">{index + 1}</span>
                        </li>
                    ))}
                    {/* <li className=" activeQuestion complteQuestion w-auto"><span className="br-50">1</span></li>
                            <li className=" activeQuestion br-50 "><span className="br-50">2</span></li>
                            <li className=" activeQuestion lockedquestion br-50 "><span className="br-50">3</span></li> */}
                </ul>
            </div>
            {(
                <div className="message_box mw-100">
                    <p>
                        <img src={image.Vector_quote} alt="quote" />
                    </p>

                    <p className="mt-3">
                        {kcData[curentQuestionIndex]?.instructions ?
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: kcData[curentQuestionIndex]?.instructions,
                                }}
                            /> : "Read the scenarios below and decide if the students have positive or negative self-esteem"
                        }
                    </p>
                </div>
            )}
            <div className="knowlwdgwchwckQuestion">
                <div className={`${kcData[curentQuestionIndex]?.type === "COMMENTQ" ? "textareatypeQuestion" : "multiplaechoicequestion"}`}>
                    <h4 className="mb-2 d-flex">
                        Q.
                        <div className="ml-1 position-relative">
                            <span
                                dangerouslySetInnerHTML={{
                                    __html:
                                        kcData[curentQuestionIndex] && kcData[curentQuestionIndex]?.question,
                                }}
                            />
                            {" "}
                            {socialActivityData?.records[0]?.series?.scenes?.length !== currentSceneObj?.sequence && (
                                <span 
                                    className="infoicons pointer"
                                    onClick={() => dispatch(showModal({ type: "QuizInformation", quizType: kcData[curentQuestionIndex]?.type }))}
                                    ><img src={image.newinfoicon} alt="info" />
                            </span>
                            )}
                        </div>

                    </h4>
                    {getSequnceSort(kcData[curentQuestionIndex]?.options)?.map((options, key) => (
                        <>
                            {kcData[curentQuestionIndex]?.type === "RADIOQ" && (
                                <div className="Ansoptions" key={key}>
                                    <label className="selAnslabel">
                                        <p className=" lighttextcolor">
                                            {options?.question}
                                            {loginType && options.isUserSelected &&
                                                 !options.isCorrect &&
                                                   socialActivityData?.records[0]?.series?.scenes?.length !== currentSceneObj?.sequence && (
                                    <>
                                        <ReactTooltip
                                            id="#dobulecheckedmsgIcon"
                                            className={"tooltip"}
                                        >
                                            Already Selected
                                        </ReactTooltip>

                                        <span
                                            data-for="#dobulecheckedmsgIcon"
                                            data-event-off=""
                                            data-tip
                                        >
                                            <i class="fa-light fa-check-double ps-2 pt-1 dobulecheckedmsgIcon"></i>
                                        </span>
                                    </>
                                )
                            }
                                        </p>
                                        <input type="radio" name="knowledgecheck"
                                            checked={loginType && options?.attempted}
                                            onClick={() => handleOptionRadio(options)}
                                        />
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            )}
                            {kcData[curentQuestionIndex]?.type === "CHECKBOXQ" && (
                                <div className="Ansoptions" key={key}>
                                    <label className="selAnslabel inputtype_checkbox">
                                        <p className=" lighttextcolor">
                                            {options?.question}
                                    {loginType && options.isUserSelected &&
                                                 !options.isCorrect &&
                                                   socialActivityData?.records[0]?.series?.scenes?.length !== currentSceneObj?.sequence && (
                                    <>
                                        <ReactTooltip
                                            id="#dobulecheckedmsgIcon"
                                            className={"tooltip"}
                                        >
                                            Already Selected
                                        </ReactTooltip>

                                        <span
                                            data-for="#dobulecheckedmsgIcon"
                                            data-event-off=""
                                            data-tip
                                        >
                                            <i class="fa-light fa-check-double ps-2 pt-1 dobulecheckedmsgIcon"></i>
                                        </span>
                                    </>
                                )
                            }
                                        </p>
                                        <input type="checkbox" name="knowledgecheck"
                                            checked={loginType && options?.attempted}
                                            onClick={() => handleOptionCheckBox(options)}
                                        />
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            )}
                            {kcData[curentQuestionIndex]?.type === "COMMENTQ" && (
                                <div className="textareabox">
                                    <textarea name={"commentbox" + curentQuestionIndex + key}
                                        id={"commentbox" + curentQuestionIndex + key}
                                        className="w-100"
                                        value={getTextAreaValue}
                                        onChange={handleTextAreaChange}
                                    >
                                    </textarea>
                                </div>
                            )}
                         
                        </>

                    ))}

                    {/* <div className="Ansoptions">
              <label className="selAnslabel">
                <p className="p2">
                  Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                  accusantium doloremque
                </p>
                <input type="radio" name="knowledgecheck" />
                <span class="checkmark"></span>
              </label>
            </div>
            <div className="Ansoptions">
              <label className="selAnslabel">
                <p className="p2">
                  Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                  accusantium doloremque
                </p>
                <input type="radio" name="knowledgecheck" />
                <span class="checkmark"></span>
              </label>
            </div> */}
                </div>
            </div>
            {/* kcData[curentQuestionIndex]?.type !== "COMMENTQ" */}
            <div className="next_prevlist w-100 text-right mt-3">
                <div className="flexone">
                     <a href="javascript:void(0)" onClick={() => handleBack()}>
                            <i class="fa-regular fa-arrow-left mr-2"></i> Previous
                        </a>
               
                {(!loginType || (kcData[curentQuestionIndex]?.attempted && kcData[curentQuestionIndex]?.type !== "COMMENTQ")) ? (
                    
                        <a 
                            href="javascript:void(0)"
                             className={`${isShowLesson() ? "disabledevent" : ""}`}
                            onClick={() => {isShowLesson() ? "" : handleNext() } }>
                            Next {(loginType && socialActivityData?.records[0]?.series?.scenes?.length === currentSceneObj?.sequence && curentQuestionIndex + 1 === kcData?.length) ? (
                                ""
                                ) : (
                                    <span>
                                        <i class="fa-regular fa-arrow-right ml-2"></i>
                                    </span>
                                )} 
                        </a>
                ) : (
                    <a href="javascript:void(0)"
                        className={`${isSubmitDisabled() ? "disabledevent" : ""}`}
                        onClick={() => {
                            isSubmitDisabled()  ? "" :
                            kcData[curentQuestionIndex]?.type === "RADIOQ"
                                ? handleSubmit(selectOptData?.questionData, selectOptData?.optNuggetData[0])
                                : kcData[curentQuestionIndex]?.type === "CHECKBOXQ" ? handleSubmitCheckBox(selectOptData?.questionData, selectOptData?.optNuggetData[0])
                                    : handelCommentChange(kcData[curentQuestionIndex])
                        }}>
                        Submit{socialActivityData?.records[0]?.series?.scenes?.length === currentSceneObj?.sequence && curentQuestionIndex + 1 === kcData?.length ? (
                                ""
                                ) : (
                                    <span>
                                        <i class="fa-regular fa-arrow-right ml-2"></i>
                                    </span>
                                )} 
                    </a>
                )}
                 </div>
            </div>
        </>

    );
};
export default UserKc;